import React from "react";

import { replaceAll } from "../../components/Base/mol_function";

export default class GoogleAnalytics extends React.Component {
  render() {
    let ga_js = `window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;

        ga('create', 'UA-55782022-1', 'auto');
        ga('set', 'anonymizeIp', true);
        ga('send', 'pageview');
        `;
    return (
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: ga_js }}
      />
    );
  }
}
